module.exports = __webpack_public_path__ + "images/anthemlogo_e9b8e0f.jpg";